<template>
    <div class="main main-padding tabs-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>用户具体使用数据</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持场景编码、行为编码关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--主要模块使用详情-->
                <div class="table-wrapper-data">
                    <Table :columns="userColumn" :data="userList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {getRankingDetail} from "../../../service/api.js";

    export default {
        name: "top-use-details",
        data () {
            return {
                schoolId: this.$route.query.schoolId,//学校id
                // schoolName: this.$route.query.schoolName,//学校名称
                userId: this.$route.query.userId,//用户id
                userName: this.$route.query.userName,//用户id
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,
                pageCount: 0,
                userColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "用户姓名",
                        key: "fullName",
                        align: "center"
                    },
                    {
                        title: "场景编码",
                        key: "funcName",
                        align: "center"
                    },
                    {
                        title: "行为编码",
                        key: "clsName",
                        align: "center"
                    },
                    {
                        title: "动态数据",
                        key: "dynamic_data",
                        align: "center"
                    },
                    {
                        title: "客户端时间",
                        key: "create_time",
                        align: "center"
                    }
                ],
                userList: []//用户列表
            }
        },
        methods:{
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "wisdomClassMain"
                });
            },
            /**
             *搜索关键字
             */
            handleSearch () {
                this.total = 0;
                this.page = 1;
                //具体使用数据
                this.findRankingDetail();
            },
            /**
             *翻页
             */
            handleCurrentChange (val) {
                this.page = val;
                //具体使用数据
                this.findRankingDetail();
            },
            /**
             *具体使用数据
             */
            async findRankingDetail () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    userId: _this.userId,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getRankingDetail(params)
                    .then(function (data) {
                        if (Object.keys(data).length !== 0) {
                            _this.userList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted(){
            // let name=this.schoolName===""? this.userName:this.schoolName;
            this.$store.commit("SET_TOPHEADERNAME", "一起智慧课堂");
            //具体使用数据
            this.findRankingDetail();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
    @import "../../../style/dataDetails";
</style>
<style lang="scss">
    .tabs-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
            top: 0;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }

        .ivu-row {
            margin-top: 0 !important;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }

        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-table-tip {
            overflow-x: hidden;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }

        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
